export const getSizeStyles = (size: string) => ({
  width: size,
  height: size,
})
